const solicitudReajusteState = {
  loading: false,
  modalSolicitudReajuste: false,
  modalSolicitudReajusteConfirmacion: false,
  modalSolicitudReajusteRespuesta: false,
  modalColsultarPeriodoReajuste: false,
  modalSolicitudReajusteConfirmacionLoading: false,
  modalConfirmarSolicitud: false,
  prestadorPuedeReplicar: false,
  usuarioPuedeReplicar: false,
  detalleValidacionCentrosAtencion: [],
  loadingValidacionSolicitudEnCurso: null,
  loadingValidacionCentrosAtencion: null,

  valorReajuste: "1",
  valorReajusteMax: 1,
  comentario: "",

  replicaPaquetes: null,
  replicaPaquetesError: false,

  replicaArancel: null,
  replicaArancelError: false,

  valorReajustePaquetes: "1",
  valorReajusteMaxPQ: 1,
  comentarioPQ: "",

  checkCentrosAtencion: [],
  checkTiposPrestacion: [],
  checkAranceles: [],
  itemsSolicitudReajuste: [],
  itemsSolicitudReajusteEliminados: 0,
  modalAceptar: false,

  checkCentrosAtencionPQ: [],
  checkVigenciaPQ: [],
  itemsSolicitudReajustePQ: [],
  itemsSolicitudReajusteEliminadosPQ: 0,
  modalAceptarPQ: false,

  valorReajusteError: "",
  checkCentrosAtencionError: false,
  checkTiposPrestacionError: false,
  checkArancelesError: false,

  valorReajustePaquetesError: "",
  checkCentrosAtencionErrorPQ: false,
  checkVigenciasErrorPQ: false,

  vigenciasPaquetes: [],
  checkVigenciasPaquetes: [],

  vigenciaReajuste: null,
  vigenciaReajustePQ: null,
  vigenciaReajustePQError: null,

  inicioVigenciaReajusteError: false,
  inicioVigenciaReajustePQError: false,

  solicitudesPendientes: [],
  solicitudesPendientesRepA: [],
  vigenciasNoEnReplica: [],

  cabeceraSolicitud: {
    IdSolicitud: null,
    IdSolicitudReplicada: null,
    IdSolicitudPQ: null,
    IdSolicitudPQReplicada: null,
  },
};

export default solicitudReajusteState;

